export default class ContractGroupFilter {
  name: string;

  cnpj: string;

  customerName: string;

  contractCustomerName: string;

  contractCnpj: string;

  contractExternalId: string;

  contractStatus: string;

  contractBeneficiary: string;

  constructor(obj: any) {
    this.name = obj.name || '';
    this.cnpj = obj.cnpj || '';
    this.customerName = obj.customerName || '';
    this.contractCustomerName = obj.contractCustomerName || '';
    this.contractCnpj = obj.contractCnpj || '';
    this.contractExternalId = obj.contractExternalId || '';
    this.contractStatus = obj.contractStatus || '';
    this.contractBeneficiary = obj.contractBeneficiary || '';
  }

  public static of(obj: any): ContractGroupFilter {
    return new ContractGroupFilter(obj || {});
  }
}
